// Base
import Link from 'next/link'

// Packages
import htmr from 'htmr'

// Components
import { Box, Flex, Text, Button } from 'yard-utilities/components'
import Section from '@components/v25/section/Section'
import FacebookReviewCard from '@components/v25/ft1/cards/review/facebook-review/FacebookReviewCard'

// Data
import data from '@data/v25/ft1/facebook-reviews.json'

interface FacebookReviewsProps {
  redirectURL: string
}

const FacebookReviews = ({ redirectURL }: FacebookReviewsProps) => {
  return (
    <Section padding={[32, 0]}>
      <Box spacing={{ sm: 32 }}>
        <Text
          tagName="h2"
          variant="title-2"
          align="center"
          transform="capitalize"
          spacing={{ sm: 32 }}
        >
          Loved by thousands of members around the world
        </Text>

        <Flex flexDirection="column" rowGap={{ sm: 24 }}>
          {data.map((review) => (
            <FacebookReviewCard key={review.name} {...review}>
              {htmr(review.text)}
            </FacebookReviewCard>
          ))}
        </Flex>
      </Box>

      <Flex center>
        <div id="faq-anchor" />

        <Button as={Link} href={redirectURL} variant="yellow-sm-shadow">
          start now
        </Button>
      </Flex>
    </Section>
  )
}

export default FacebookReviews
